/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './CircleButton.css';

import Circle from 'components/images/Circle';

const CircleButton = ({ children, onClick, alignRight, alignLeft, colorClassName }) => (
  <button className={classnames("cmp-circlebutton", { 'alignRight': alignRight, 'alignLeft': alignLeft })} onClick={onClick}>
    <div className="background"><Circle size={32} className={colorClassName} /></div>
    <div className="icon">{children}</div>
  </button>
);
CircleButton.propTypes = {
  size: PropTypes.number,
  fontSize: PropTypes.number,
  text: PropTypes.string,
  colorClassName: PropTypes.string,
};
CircleButton.defaultProps = {
  size: 34,
  fontSize: 14,
  strokeWidth: 1,
};

export default CircleButton;